// removed by extract-text-webpack-plugin
module.exports = {"post":"src-styles----shows-module---post---1tLC-","title":"src-styles----shows-module---title---2ckRW","image":"src-styles----shows-module---image---1cW3d"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/shows.module.scss
// module id = 303
// module chunks = 19647912047630